import styled from "@emotion/styled";

export const Root = styled("div")({
    ":focus": {
        outline: "none",
    },
    marginTop: "4px",
});
